<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-30 17:53:30
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftTypeMapping\components\newShiftTypeMapping.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-14 13:59:23
-->
<template>
  <normalDialog
    :dialog="show"
    :title="$t('label_essweb_shiftTypeMapping_dialog_newShiftTypeMappingTitle')"
    @close="closeDialog"
    width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form">
        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
          <AutoComplete
            isRequired
            label="label_essweb_shiftTypeMapping_dialog_staffNameLabel"
            v-model="selectStaff"
            :items="StaffList"
            :filter="$staffFilter"
            :rules="
              selectStaff == '' ? $GetRules(['_Require_ArrRules'], [null]) : []
            "
            chips
            deletable-chips
            multiple
            two-line
            avatar
            item-text="staff_code"
            item-value="staff_id"
          >
            <template v-slot:selection.avatar="{ data }">
              <StaffAvatar
                :src="data.item.staff_avatar"
                :isTemp="data.item.is_temp"
                left
                :staff_name="data.item.preferred_name"
              />
            </template>
            <template v-slot:selection="{ data }">
              {{ $getCommonLangValue(data.item.preferred_name) }}
            </template>
            <template v-slot:item.avatar="{ data }">
              <StaffAvatar
                size="36"
                :isTemp="data.item.is_temp"
                :src="data.item.staff_avatar"
                :staff_name="data.item.preferred_name"
              />
            </template>
            <template v-slot:item.title="{ data }">
              <span class="text-body-2"
                >{{ $getCommonLangValue(data.item.preferred_name) }}
                <span class="text--secondary text-caption-xs">{{
                  data.item.staff_code
                }}</span></span
              >
            </template>
            <template v-slot:item.subtitle="{ data }">
              {{ $getCommonLangValue(data.item.job_post_name) }}
            </template>
          </AutoComplete>
        </v-col>
        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
          <AutoComplete
            isRequired
            :items="ShiftTypeList"
            label="label_essweb_shiftTypeMapping_dialog_staffTypeLabel"
            item-text="shift_type_name"
            item-value="uuid"
            chips
            small-chips
            deletable-chips
            v-model="selectType"
            multiple
            :rules="$GetRules(['_Require_ArrRules'], [null])"
          >
          </AutoComplete>
        </v-col>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="onNew" @cancel="closeDialog" />
    </template>
    <template v-slot:tools> </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newShiftTypeMapping",
  computed: {
    ...mapGetters(["companyLang"]),
    ShiftTypeList() {
      return this.$getSelectTrans(this.ShiftTypeListData, "shift_type_name");
    },
  },
  props: { show: { default: false, type: Boolean } },
  data() {
    return {
      StaffList: [],
      selectStaff: [],
      // showSelectStaff: false,
      ShiftTypeListData: [],
      selectType: [],
    };
  },
  watch: {
    show(val) {
      if (!val) {
        this.selectStaff = "";
        this.selectType = [];
      }
    },
  },
  mounted() {
    this.$getStaffList().then((res) => {
      this.StaffList = res;
    });
    this.getType();
  },
  methods: {
    removeType: function (item) {
      const index = this.selectType.indexOf(item.uuid);
      if (index >= 0) this.selectType.splice(index, 1);
    },
    getStaff: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_staffs",
        url: "/staff/get-staff-list/",
      }).then((res) => {
        that.StaffList = res.data;
      });
    },
    // 改为底层接口 daveluo
    // getStaff: function () {
    //   const that = this;
    //   this.$Request({
    //     method: "POST",
    //     table: "mrbase_sys_staffs",
    //     url: "/staff/get-staff-list/",

    //   }).then((res) => {
    //     that.StaffList = res.data;
    //   });
    // },
    getType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-list/",
      }).then((res) => {
        that.ShiftTypeListData = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    removePeople: function (item) {
      const index = this.selectStaff.indexOf(item.staff_id); //2020-10-20 staff_id-->user_id
      if (index >= 0) this.selectStaff.splice(index, 1);
    },
    onNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", {
        staffIds: this.selectStaff.length ? this.selectStaff.join(",") : "",
        shiftTypeIds: this.selectType.length ? this.selectType.join(",") : "",
      });
    },
  },
};
</script>
